<template>
  <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
      <StackedField :label="t('charged_by')" :value="chargedBy" />
    </div>
    <div class="mt-6">
      <Table :columns="columns" :data="rows">
        <template #amount="{ row }">
          <span :class="['text-sm font-medium', row.billingType === 'collected' ? 'text-green-500' : 'text-red-500']">
            {{ row.amount }}
          </span>
        </template>
        <template #storeCommission="{ row }">
          <span
            class="inline-flex items-center rounded-full px-2 py-1 text-xs font-medium bg-purple-100 text-purple-700"
          >
            {{ row.storeCommission }}
          </span>
        </template>
        <template #period="{ row }">
          <span class="text-sm font-medium text-gray-900">{{ row.period }}</span>
        </template>
        <template #paymentStatus="{ row }">
          <span class="text-sm font-medium text-gray-900">
            {{ $t("planSaleBilling.paymentStatus." + row.paymentStatus) }}
          </span>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { Table, StackedField, formatPrice } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  name: "PlanSaleBillingDetails",

  components: { Table, StackedField },

  props: {
    planSaleBillings: {
      type: Array,
      required: true,
      default: () => [],
    },
    chargedBy: {
      type: String,
      default: null,
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    columns() {
      return [
        { label: this.t("column_amount"), field: "amount", slot: "amount" },
        { label: this.t("column_commission"), field: "storeCommission", slot: "storeCommission" },
        { label: this.t("column_period"), field: "period", slot: "period" },
        { label: this.t("column_status"), field: "paymentStatus", slot: "paymentStatus" },
      ];
    },

    rows() {
      return this.planSaleBillings.map((billing) => {
        const storeCommission = billing.commissions?.find((commission) => commission.subjectType === "Store");
        const paymentStatus = billing.uncollectible ? "uncollectible" : billing.paymentStatus;
        return {
          ...billing,
          storeCommission: formatPrice(storeCommission?.amount),
          period: this.t("period_range", { start: billing.startDate, end: billing.endDate }),
          amount: formatPrice(billing.finalPrice),
          paymentStatus,
          rowClass: paymentStatus === "failed" ? "bg-red-100" : "",
        };
      });
    },
  },
};
</script>

<i18n src="./PlanSaleBillingDetails.i18n.json"></i18n>
